import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { getPlanConfig } from '../../utils/membershipUtils';
import Pagination from '../../components/Pagination/Pagination';
import './CompanyProductsPage.css';

const CompanyProductsPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const supplierId = id || '68';
  const [activeTab, setActiveTab] = useState('product');
  const [expandedCategories, setExpandedCategories] = useState({
    'building-materials': true
  });
  const [currentPage, setCurrentPage] = useState(1);

  const categories = [
    {
      id: 'building-materials',
      name: 'Building Materials',
      active: true,
      subcategories: [
        { name: 'Cement', active: true },
        { name: 'Sand', active: false },
        { name: 'Stone', active: false },
        { name: 'Steel rods', active: false },
      ]
    },
    { id: 'structural-work', name: 'Structural Work', active: false },
    { id: 'interior-finishing', name: 'Interior & Finishing', active: false },
    { id: 'plumbing', name: 'Plumbing & Sanitary', active: false },
    { id: 'electrical', name: 'Electrical Works', active: false },
    { id: 'hvac', name: 'HVAC', active: false },
    { id: 'scaffolding', name: 'Scaffolding & Shuttering', active: false },
    { id: 'scaffolding2', name: 'Scaffolding & Shuttering', active: false },
  ];

  // Cement bag image from Figma
  const cementImage = 'https://api.builder.io/api/v1/image/assets/TEMP/328a0f6dd6e767b8279791bf791abd79bf7b4c61?width=226';
  
  const products = Array(16).fill(null).map((_, index) => ({
    id: index + 1,
    image: cementImage,
    title: 'Construction of 15 story commercial office building with modern amenities and parking facilities.',
    price: '$2.5 - $3.2 USD',
    unit: '/ Tons',
    moq: 'I5 Tons',
    badge: 'Global',
    verified: true,
    country: 'USA',
    years: '01 Year',
    type: 'Manufacture'
  }));

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const VerifiedBadge = () => (
    <svg width="118" height="30" viewBox="0 0 118 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 15C22 15.9323 20.7329 16.6871 20.5034 17.5472C20.2653 18.4377 20.9782 19.7221 20.528 20.5015C20.0705 21.2923 18.597 21.314 17.9562 21.9562C17.314 22.5984 17.2923 24.0705 16.5014 24.528C15.7221 24.9782 14.4377 24.2653 13.5472 24.5034C12.6871 24.7329 11.9337 26 11 26C10.0663 26 9.31291 24.7329 8.45276 24.5034C7.56231 24.2653 6.27788 24.9782 5.49856 24.528C4.70769 24.0705 4.68605 22.597 4.04382 21.9562C3.4016 21.3154 1.92954 21.2923 1.47205 20.5015C1.02177 19.7221 1.73472 18.4377 1.49659 17.5472C1.26712 16.6871 0 15.9338 0 15C0 14.0663 1.26712 13.3129 1.49659 12.4528C1.73472 11.5623 1.02177 10.2779 1.47205 9.49857C1.92954 8.7077 3.40305 8.68605 4.04382 8.04383C4.68605 7.40161 4.70769 5.92955 5.49856 5.47206C6.27788 5.02178 7.56231 5.73472 8.45276 5.49659C9.31291 5.26712 10.0663 4 11 4C11.9337 4 12.6871 5.26712 13.5472 5.49659C14.4377 5.73472 15.7221 5.02178 16.5014 5.47206C17.2923 5.92955 17.314 7.40305 17.9562 8.04383C18.5984 8.68461 20.0705 8.7077 20.528 9.49857C20.9782 10.2779 20.2653 11.5623 20.5034 12.4528C20.7329 13.3129 22 14.0663 22 15Z" fill="#29ABE2"/>
      <path d="M16.5881 11.6015C16.1234 11.1368 15.3701 11.1368 14.9054 11.6015L10.0317 16.4751L8.00835 14.4518C7.54364 13.9871 6.79029 13.9871 6.32558 14.4518C5.86087 14.9165 5.86087 15.6698 6.32558 16.1345L9.14847 18.9574C9.39237 19.2013 9.7142 19.3168 10.0331 19.3052C10.3521 19.3168 10.6734 19.2013 10.9173 18.9574L16.5891 13.2857C17.0538 12.821 17.0538 12.0676 16.5891 11.6029L16.5881 11.6015Z" fill="white"/>
      <text fill="#29ABE2" xmlSpace="preserve" style={{whiteSpace: 'pre'}} fontFamily="Poppins" fontSize="17" letterSpacing="0em"><tspan x="27" y="20.95">Verified</tspan></text>
    </svg>
  );

  const ManufactureIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 5H12V6H14.5V9H11V10H12.5V11.071C12.0287 11.1927 11.6179 11.4821 11.3447 11.885C11.0715 12.2879 10.9546 12.7766 11.0159 13.2595C11.0773 13.7424 11.3126 14.1864 11.6779 14.5082C12.0431 14.83 12.5132 15.0075 13 15.0075C13.4868 15.0075 13.9569 14.83 14.3221 14.5082C14.6874 14.1864 14.9227 13.7424 14.9841 13.2595C15.0454 12.7766 14.9285 12.2879 14.6553 11.885C14.3821 11.4821 13.9713 11.1927 13.5 11.071V10H14.5C14.7651 9.9996 15.0192 9.89412 15.2067 9.70667C15.3941 9.51922 15.4996 9.26509 15.5 9V6C15.5 5.73478 15.3946 5.48043 15.2071 5.29289C15.0196 5.10536 14.7652 5 14.5 5ZM14 13C14 13.1978 13.9414 13.3911 13.8315 13.5556C13.7216 13.72 13.5654 13.8482 13.3827 13.9239C13.2 13.9996 12.9989 14.0194 12.8049 13.9808C12.6109 13.9422 12.4327 13.847 12.2929 13.7071C12.153 13.5673 12.0578 13.3891 12.0192 13.1951C11.9806 13.0011 12.0004 12.8 12.0761 12.6173C12.1518 12.4346 12.28 12.2784 12.4444 12.1685C12.6089 12.0586 12.8022 12 13 12C13.2651 12.0004 13.5192 12.1059 13.7067 12.2933C13.8941 12.4808 13.9996 12.7349 14 13ZM9.5 3H7V4H9.5V7H6V8H7.5V11.071C7.02867 11.1927 6.61791 11.4821 6.3447 11.885C6.07149 12.2879 5.9546 12.7766 6.01594 13.2595C6.07728 13.7424 6.31263 14.1864 6.67788 14.5082C7.04314 14.83 7.51321 15.0075 8 15.0075C8.48679 15.0075 8.95686 14.83 9.32212 14.5082C9.68737 14.1864 9.92272 13.7424 9.98406 13.2595C10.0454 12.7766 9.92851 12.2879 9.6553 11.885C9.3821 11.4821 8.97133 11.1927 8.5 11.071V8H9.5C9.76522 8 10.0196 7.89464 10.2071 7.70711C10.3946 7.51957 10.5 7.26522 10.5 7V4C10.5 3.73478 10.3946 3.48043 10.2071 3.29289C10.0196 3.10536 9.76522 3 9.5 3ZM9 13C9 13.1978 8.94135 13.3911 8.83147 13.5556C8.72159 13.72 8.56541 13.8482 8.38268 13.9239C8.19996 13.9996 7.99889 14.0194 7.80491 13.9808C7.61093 13.9422 7.43275 13.847 7.29289 13.7071C7.15304 13.5673 7.0578 13.3891 7.01921 13.1951C6.98063 13.0011 7.00043 12.8 7.07612 12.6173C7.15181 12.4346 7.27998 12.2784 7.44443 12.1685C7.60888 12.0586 7.80222 12 8 12C8.26509 12.0004 8.51922 12.1059 8.70667 12.2933C8.89412 12.4808 8.9996 12.7349 9 13ZM4.5 1H1.5C1.23478 1 0.98043 1.10536 0.792893 1.29289C0.605357 1.48043 0.5 1.73478 0.5 2V5C0.5 5.26522 0.605357 5.51957 0.792893 5.70711C0.98043 5.89464 1.23478 6 1.5 6H2.5V11.071C2.02867 11.1927 1.61791 11.4821 1.3447 11.885C1.07149 12.2879 0.954603 12.7766 1.01594 13.2595C1.07728 13.7424 1.31263 14.1864 1.67788 14.5082C2.04314 14.83 2.51321 15.0075 3 15.0075C3.48679 15.0075 3.95686 14.83 4.32212 14.5082C4.68737 14.1864 4.92272 13.7424 4.98406 13.2595C5.0454 12.7766 4.92851 12.2879 4.6553 11.885C4.38209 11.4821 3.97133 11.1927 3.5 11.071V6H4.5C4.76522 6 5.01957 5.89464 5.20711 5.70711C5.39464 5.51957 5.5 5.26522 5.5 5V2C5.5 1.73478 5.39464 1.48043 5.20711 1.29289C5.01957 1.10536 4.76522 1 4.5 1ZM4 13C4 13.1978 3.94135 13.3911 3.83147 13.5556C3.72159 13.72 3.56541 13.8482 3.38268 13.9239C3.19996 13.9996 2.99889 14.0194 2.80491 13.9808C2.61093 13.9422 2.43275 13.847 2.29289 13.7071C2.15304 13.5673 2.0578 13.3891 2.01921 13.1951C1.98063 13.0011 2.00043 12.8 2.07612 12.6173C2.15181 12.4346 2.27998 12.2784 2.44443 12.1685C2.60888 12.0586 2.80222 12 3 12C3.26522 12 3.51957 12.1054 3.70711 12.2929C3.89464 12.4804 4 12.7348 4 13ZM1.5 5V2H4.5L4.501 5H1.5Z" fill="#6D6D6D"/>
    </svg>
  );

  const ProductCard = ({ product }) => (
    <div className="cpp-product-card">
      <div className="cpp-product-image-wrapper">
        <img src={product.image} alt={product.title} className="cpp-product-image" />
      </div>
      <div className="cpp-product-content">
        <div className="cpp-product-info">
          <div className="cpp-product-details">
            <p className="cpp-product-title">{product.title}</p>
            <div className="cpp-product-pricing">
              <span className="cpp-product-price">{product.price}</span>
              <span className="cpp-product-unit"> {product.unit}</span>
            </div>
            <div className="cpp-product-moq">
              <span className="cpp-moq-value">{product.moq}</span>
              <span className="cpp-moq-label"> (MOQ)</span>
            </div>
          </div>
          <div className="cpp-product-badges">
            <div className="cpp-badge-row">
              <div className="cpp-global-badge">
                <img src="https://api.builder.io/api/v1/image/assets/TEMP/050559d54da8d35ba6d11841efdb737d4c3ae660?width=44" alt="Platinum" className="cpp-platinum-icon" />
                <span>{product.badge}</span>
              </div>
              {product.verified && <VerifiedBadge />}
            </div>
            <img 
              src="https://api.builder.io/api/v1/image/assets/TEMP/8c0d270e930b0365d2b9bc2dcd7dae8d6b170333?width=332" 
              alt="Container" 
              className="cpp-container-image" 
            />
            <div className="cpp-seller-info">
              <div className="cpp-country-row">
                <div className="cpp-flag-wrapper">
                  <img src="https://api.builder.io/api/v1/image/assets/TEMP/b5a3d45770e1a15bb716894fd27f95e08cf4ad67?width=62" alt="Flag" className="cpp-flag-icon" />
                </div>
                <span className="cpp-country-text">
                  <span className="cpp-country-name">{product.country} / </span>
                  <span className="cpp-member-years">{product.years}</span>
                </span>
              </div>
            </div>
          </div>
          <div className="cpp-product-type">
            <ManufactureIcon />
            <span>{product.type}</span>
          </div>
        </div>
        <div className="cpp-product-actions">
          <button className="cpp-btn-inquire">Inquire Now</button>
          <button className="cpp-btn-mobile">
            <span>View mobile</span>
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="company-products-page">
      <Header />
      
      {/* Company Header Section */}
      <div className="cpp-company-header">
        <div className="cpp-company-header-content">
          <div className="cpp-company-info-row">
            <div className="cpp-company-identity">
              <img 
                src="https://api.builder.io/api/v1/image/assets/TEMP/4fe949ae73c9ac863b6fb61997bb04e8c261413f?width=160" 
                alt="Company Logo" 
                className="cpp-company-logo" 
              />
              <div className="cpp-company-details">
                <h1 className="cpp-company-name">Eiffage Construction</h1>
                <div className="cpp-company-meta">
                  <div className="cpp-meta-badges">
                    {(() => {
                      const planConfig = getPlanConfig('global-enterprise');
                      return (
                        <div className="cpp-global-badge" style={{ borderColor: planConfig.color }}>
                          <img src={planConfig.icon} alt={planConfig.label} className="cpp-platinum-icon" />
                          <span style={{ color: planConfig.color }}>{planConfig.label}</span>
                        </div>
                      );
                    })()}
                    <VerifiedBadge />
                  </div>
                  <div className="cpp-country-info">
                    <div className="cpp-flag-wrapper-large">
                      <img src="https://api.builder.io/api/v1/image/assets/TEMP/23ed0e62e10103a924032bcc2322be51eddf65ca?width=124" alt="Flag" className="cpp-flag-large" />
                    </div>
                    <span className="cpp-country-text-large">United State / <strong>01 Year</strong></span>
                  </div>
                  <div className="cpp-manufacture-info">
                    <ManufactureIcon />
                    <span>Manufacture</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="cpp-stats-box">
              <span className="cpp-stat">0 Reviews</span>
              <div className="cpp-stat-divider"></div>
              <span className="cpp-stat">20 Products</span>
            </div>
          </div>
          
          {/* Bookmark Icon */}
          <svg className="cpp-bookmark-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M22 0H11.5C11.1022 0 10.7206 0.158035 10.4393 0.43934C10.158 0.720644 10 1.10218 10 1.5V18C10.0001 18.1338 10.036 18.2652 10.1039 18.3805C10.1719 18.4958 10.2695 18.5908 10.3866 18.6557C10.5037 18.7206 10.636 18.7529 10.7698 18.7494C10.9036 18.7458 11.034 18.7066 11.1475 18.6356L16.75 15.1341L22.3534 18.6356C22.4669 18.7063 22.5972 18.7454 22.7309 18.7488C22.8646 18.7522 22.9967 18.7198 23.1136 18.655C23.2306 18.5902 23.3281 18.4953 23.396 18.3801C23.4639 18.2649 23.4998 18.1337 23.5 18V1.5C23.5 1.10218 23.342 0.720644 23.0607 0.43934C22.7794 0.158035 22.3978 0 22 0ZM22 16.6472L17.1466 13.6144C17.0274 13.5399 16.8896 13.5004 16.7491 13.5004C16.6085 13.5004 16.4708 13.5399 16.3516 13.6144L11.5 16.6472V1.5H22V16.6472Z" fill="#969696"/>
          </svg>
          
          <div className="cpp-tabs">
            <button 
              className={`cpp-tab ${activeTab === 'home' ? 'active' : ''}`}
              onClick={() => navigate(`/supplier/${supplierId}`)}
            >
              Home
            </button>
            <button 
              className={`cpp-tab ${activeTab === 'profile' ? 'active' : ''}`}
              onClick={() => navigate(`/supplier/${supplierId}/profile`)}
            >
              Company Profile
            </button>
            <button 
              className={`cpp-tab ${activeTab === 'product' ? 'active' : ''}`}
              onClick={() => navigate(`/supplier/${supplierId}/products`)}
            >
              Product
            </button>
            <button 
              className={`cpp-tab ${activeTab === 'contact' ? 'active' : ''}`}
              onClick={() => navigate(`/supplier/${supplierId}/contact`)}
            >
              Contact
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="cpp-main-content">
        {/* Breadcrumb */}
        <div className="cpp-breadcrumb">
          <Link to="/" className="cpp-breadcrumb-link">Supplier homepage</Link>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 13L10 9L6 5" stroke="#505050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="cpp-breadcrumb-current">Product</span>
        </div>

        {/* Content Layout */}
        <div className="cpp-content-layout">
          {/* Sidebar */}
          <div className="cpp-sidebar">
            <div className="cpp-category-list">
              {categories.map((category) => (
                <div key={category.id} className="cpp-category-section">
                  <div 
                    className="cpp-category-header"
                    onClick={() => category.subcategories && toggleCategory(category.id)}
                  >
                    <div className="cpp-category-name-wrapper">
                      <span className={`cpp-category-name ${category.active ? 'active' : ''}`}>
                        {category.name}
                      </span>
                    </div>
                    <svg 
                      className={`cpp-category-arrow ${expandedCategories[category.id] ? 'expanded' : ''}`} 
                      width="24" 
                      height="24" 
                      viewBox="0 0 24 24" 
                      fill="none"
                    >
                      {category.subcategories ? (
                        <path d="M17 10L12 15L7 10" stroke={category.active ? '#333' : '#6D6D6D'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      ) : (
                        <path d="M10 17L15 12L10 7" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      )}
                    </svg>
                  </div>
                  {category.subcategories && expandedCategories[category.id] && (
                    <div className="cpp-subcategory-list">
                      {category.subcategories.map((sub, idx) => (
                        <div key={idx} className={`cpp-subcategory-item ${sub.active ? 'active' : ''}`}>
                          {sub.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Products Grid */}
          <div className="cpp-products-section">
            <div className="cpp-products-grid">
              {products.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>

            {/* Pagination */}
            <Pagination currentPage={currentPage} totalPages={5} onPageChange={setCurrentPage} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CompanyProductsPage;
